/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

enum numericalBreakpoints {
  xs = 360,
  sm = 480,
  md = 840,
  lg = 960,
  xl = 1280,
  card = 560
}

const breakpoints = {
  xs: `${numericalBreakpoints.xs}px`,
  sm: `${numericalBreakpoints.sm}px`,
  md: `${numericalBreakpoints.md}px`,
  lg: `${numericalBreakpoints.lg}px`,
  xl: `${numericalBreakpoints.xl}px`,
  card: `${numericalBreakpoints.card}px`
};

const gridUtils = {
  numericalBreakpoints,
  breakpoints
};

export default gridUtils;
